const ProfileCard = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  return (
    <section>
      <div className="container">
        <div className="row align-items-top justify-content-center">
          <div className="col text-center pb-5">
            <h2 className="font-bold text-black text-4xl">The Master Brand Craftsman <span className="d-block  text-red ">Behind the World’s Most Important Brands</span></h2>
          </div>
        </div>
        <div className="row align-items-top justify-content-center">
          <div className="col-12 col-md-6">
            <img
              alt="Profile"
              className="img-fluid"
              src={`${awsImageBaseUrl}images/PeoplePurposet/headshots/BillSmith-CEO.png`} 
            />
          </div>
          <div className="col-12 col-md-6">
            <div className="card-body mt-3 mt-md-0">
              <h5 className="font-bold text-black text-3xl">Bill Smith, <span className="text-red">Founder and CEO</span></h5>
              <p>
                Across industries, <span className="font-bold text-black">Bill Smith’s</span> naming work has become embedded in daily life. From gaming consoles and enterprise software to email platforms and productivity tools, his names power ecosystems used by over 2 billion people <span className="font-bold text-black">worldwide</span>—an unmatched reach in the field of strategic branding.
              </p>
              <p>
              <span className="font-bold text-black">Bill Smith</span> is the only person in history to have created three brand names for a single company <span className="font-bold text-black">Microsoft</span>—that have each individually generated tens of billions in lifetime revenue:
              </p>
              <ul className="list-unstyled list-group list-group-horizontal-xl pb-4">
                <li className="list-group-item font-bold text-black border-0 text-3xl">XBox</li>
                <li className="list-group-item font-bold text-black border-0 text-3xl">Outlook</li>
                <li className="list-group-item font-bold text-black border-0 text-3xl">Excel</li>
              </ul>
              <p>
                Together, these names are part of one of the most economically impactful naming portfolios ever developed by a single individual.
              </p>
              <p>
                When profiling the art and influence of corporate naming, The New York Times called Bill Smith “perhaps the greatest at the craft of naming that has ever lived.”
              </p>
              <p>
                His legacy spans consumer tech, pharma, finance, automotive, and beyond—earning him recognition as the strategist behind the words that move markets.
              </p>
              <div className="d-flex mt-4">
                <a className="btn btn-sm me-2" href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-facebook"></i>
                </a>
                <a className="btn btn-sm me-2" href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-twitter"></i>
                </a>
                <a className="btn btn-sm" href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-linkedin"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="row align-items-top justify-content-center">
          <div className="col text-center py-5">
            <h3 className="font-bold text-black text-4xl">Executive Team</h3>
          </div>
        </div>
        <div className="row align-items-center justify-content-center">
          <div className="col-12 col-md-6 order-2 order-lg-1">
            <div className="card-body mt-3 mt-md-0">
            <h5 className="font-bold text-black text-3xl">Kim Miller, <span className="text-red">COO</span></h5>
              <p>
                Kim has been an integral member of the Brand Acumen Studios team since 2011. Reporting to CEO Bill Smith, she oversees day-to-day business operations, research and development, marketing efforts and client relations. Though she’s collaborated on thousands of naming projects throughout her time at Brand Acumen, her work on General Motors’ Cadillac LYRIQ and Ultium battery names is particularly memorable.              </p>
              <div className="d-flex mt-4">
                <a className="btn btn-sm me-2" href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-facebook"></i>
                </a>
                <a className="btn btn-sm me-2" href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-twitter"></i>
                </a>
                <a className="btn btn-sm" href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-linkedin"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 order-1 order-lg-2">
            <img
              alt="Profile"
              className="img-fluid img-radius"
              src={`${awsImageBaseUrl}images/PeoplePurposet/headshots/Kim_Miller-CCO.png`} 
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileCard;
